import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
} from "@mui/material";

interface ConfirmIgnoreModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  id?: string | null;
  dealName?: string | null;
  isSubmitting?: boolean;
  statusMessage?: string;
}

const ConfirmIgnoreModal: React.FC<ConfirmIgnoreModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  id,
  dealName,
  isSubmitting = false,
  statusMessage,
}) => {
  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Ignore row</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          This will add the selected row to the ignore list.
        </Typography>
        {(dealName || id) && (
          <List dense sx={{ listStyleType: "disc", pl: 4 }}>
            {dealName && (
              <ListItem sx={{ display: "list-item", pl: 0 }}>
                <Typography variant="body2">
                  Deal Name: <strong>{dealName}</strong>
                </Typography>
              </ListItem>
            )}
            {id && (
              <ListItem sx={{ display: "list-item", pl: 0 }}>
                <Typography variant="body2">
                  Deal ID: <strong>{id}</strong>
                </Typography>
              </ListItem>
            )}
          </List>
        )}
        <Typography variant="body1" sx={{ mt: 1 }}>
          Continue?
        </Typography>
        {statusMessage && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 2 }}
          >
            {statusMessage}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          disabled={isSubmitting}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirm}
          disabled={isSubmitting}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmIgnoreModal;
